// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gift-notification-banner {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px;
    border-radius: 12px;
    margin-bottom: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: slideInDown 0.5s ease-out;
}

@keyframes slideInDown {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.gift-banner-content {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 15px;
}

.gift-banner-icon {
    font-size: 48px;
    animation: bounce 1s infinite;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

.gift-banner-text {
    color: white;
}

.gift-banner-text strong {
    font-size: 20px;
    display: block;
    margin-bottom: 5px;
}

.gift-banner-text p {
    margin: 0;
    opacity: 0.9;
    font-size: 14px;
}

.gift-banner-gifts {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
}

.gift-item-button {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 12px 16px;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    font-weight: 600;
    transition: all 0.3s ease;
}

.gift-item-button:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.gift-item-icon {
    font-size: 24px;
}

.gift-item-title {
    flex: 1 1;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Modal styles */
.gift-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: var(--z-modal-backdrop);
    padding: 20px;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.gift-modal {
    background: white;
    border-radius: 16px;
    max-width: 500px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
    animation: scaleIn 0.3s ease-out;
}

@keyframes scaleIn {
    from {
        transform: scale(0.9);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.gift-modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 16px 16px 0 0;
}

.gift-modal-header h2 {
    margin: 0;
    font-size: 24px;
}

.gift-modal-close {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    font-size: 32px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.gift-modal-close:hover {
    background: rgba(255, 255, 255, 0.3);
}

.gift-modal-body {
    padding: 30px;
}

.gift-description {
    color: #666;
    line-height: 1.6;
    margin-bottom: 30px;
    font-size: 16px;
}

.gift-reward-display {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 24px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
}

.gift-reward-icon {
    font-size: 64px;
    line-height: 1;
}

.gift-reward-image {
    width: 110px;
    height: auto;
    border-radius: 8px;
    object-fit: contain;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.gift-reward-details h3 {
    margin: 0 0 10px 0;
    color: #333;
    font-size: 20px;
}

.gift-reward-details p {
    margin: 5px 0;
    color: #666;
}

.gift-reward-amount,
.gift-reward-theme,
.gift-reward-booster,
.gift-reward-char {
    font-size: 15px;
}

.gift-claim-message {
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 20px;
    text-align: center;
}

.gift-claim-message.success {
    background: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.gift-claim-message.error {
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

.gift-claim-message p {
    margin: 0;
    font-weight: 600;
}

.reward-details {
    margin-top: 10px;
}

.reward-message {
    margin-top: 8px !important;
    font-size: 14px;
    font-weight: normal !important;
}

.card-generated {
    background: rgba(255, 255, 255, 0.5);
    padding: 15px;
    border-radius: 8px;
    margin-top: 12px;
    border: 2px solid rgba(21, 87, 36, 0.3);
}

.card-generated p {
    margin: 5px 0;
}

.card-generated strong {
    color: #155724;
}

.gift-modal-footer {
    padding: 20px 30px;
    border-top: 1px solid #e0e0e0;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

.gift-claim-button {
    padding: 12px 32px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    flex: 1 1;
}

.gift-claim-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.5);
}

.gift-claim-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.gift-close-button {
    padding: 12px 24px;
    background: #6c757d;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.gift-close-button:hover {
    background: #545b62;
}

@media (max-width: 768px) {
    .gift-banner-gifts {
        grid-template-columns: 1fr;
    }

    .gift-modal {
        margin: 10px;
    }

    .gift-modal-body {
        padding: 20px;
    }

    .gift-reward-display {
        flex-direction: column;
        text-align: center;
    }

    .gift-modal-footer {
        flex-direction: column;
    }

    .gift-claim-button {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/gifts/GiftNotification.css"],"names":[],"mappings":"AAAA;IACI,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,oCAAoC;AACxC;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,gCAAgC;AACpC;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,6DAA6D;IAC7D,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,SAAO;AACX;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".gift-notification-banner {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    padding: 20px;\n    border-radius: 12px;\n    margin-bottom: 24px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    animation: slideInDown 0.5s ease-out;\n}\n\n@keyframes slideInDown {\n    from {\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.gift-banner-content {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    margin-bottom: 15px;\n}\n\n.gift-banner-icon {\n    font-size: 48px;\n    animation: bounce 1s infinite;\n}\n\n@keyframes bounce {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-10px);\n    }\n}\n\n.gift-banner-text {\n    color: white;\n}\n\n.gift-banner-text strong {\n    font-size: 20px;\n    display: block;\n    margin-bottom: 5px;\n}\n\n.gift-banner-text p {\n    margin: 0;\n    opacity: 0.9;\n    font-size: 14px;\n}\n\n.gift-banner-gifts {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n    gap: 10px;\n}\n\n.gift-item-button {\n    background: rgba(255, 255, 255, 0.2);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    padding: 12px 16px;\n    border-radius: 8px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: white;\n    font-weight: 600;\n    transition: all 0.3s ease;\n}\n\n.gift-item-button:hover {\n    background: rgba(255, 255, 255, 0.3);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.gift-item-icon {\n    font-size: 24px;\n}\n\n.gift-item-title {\n    flex: 1;\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Modal styles */\n.gift-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: var(--z-modal-backdrop);\n    padding: 20px;\n    animation: fadeIn 0.3s ease-out;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n.gift-modal {\n    background: white;\n    border-radius: 16px;\n    max-width: 500px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n    animation: scaleIn 0.3s ease-out;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.9);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.gift-modal-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-radius: 16px 16px 0 0;\n}\n\n.gift-modal-header h2 {\n    margin: 0;\n    font-size: 24px;\n}\n\n.gift-modal-close {\n    background: rgba(255, 255, 255, 0.2);\n    border: none;\n    color: white;\n    font-size: 32px;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: background 0.2s;\n}\n\n.gift-modal-close:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n.gift-modal-body {\n    padding: 30px;\n}\n\n.gift-description {\n    color: #666;\n    line-height: 1.6;\n    margin-bottom: 30px;\n    font-size: 16px;\n}\n\n.gift-reward-display {\n    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n    padding: 24px;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n}\n\n.gift-reward-icon {\n    font-size: 64px;\n    line-height: 1;\n}\n\n.gift-reward-image {\n    width: 110px;\n    height: auto;\n    border-radius: 8px;\n    object-fit: contain;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n}\n\n.gift-reward-details h3 {\n    margin: 0 0 10px 0;\n    color: #333;\n    font-size: 20px;\n}\n\n.gift-reward-details p {\n    margin: 5px 0;\n    color: #666;\n}\n\n.gift-reward-amount,\n.gift-reward-theme,\n.gift-reward-booster,\n.gift-reward-char {\n    font-size: 15px;\n}\n\n.gift-claim-message {\n    padding: 15px;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.gift-claim-message.success {\n    background: #d4edda;\n    color: #155724;\n    border: 1px solid #c3e6cb;\n}\n\n.gift-claim-message.error {\n    background: #f8d7da;\n    color: #721c24;\n    border: 1px solid #f5c6cb;\n}\n\n.gift-claim-message p {\n    margin: 0;\n    font-weight: 600;\n}\n\n.reward-details {\n    margin-top: 10px;\n}\n\n.reward-message {\n    margin-top: 8px !important;\n    font-size: 14px;\n    font-weight: normal !important;\n}\n\n.card-generated {\n    background: rgba(255, 255, 255, 0.5);\n    padding: 15px;\n    border-radius: 8px;\n    margin-top: 12px;\n    border: 2px solid rgba(21, 87, 36, 0.3);\n}\n\n.card-generated p {\n    margin: 5px 0;\n}\n\n.card-generated strong {\n    color: #155724;\n}\n\n.gift-modal-footer {\n    padding: 20px 30px;\n    border-top: 1px solid #e0e0e0;\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n.gift-claim-button {\n    padding: 12px 32px;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    flex: 1;\n}\n\n.gift-claim-button:hover:not(:disabled) {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.5);\n}\n\n.gift-claim-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.gift-close-button {\n    padding: 12px 24px;\n    background: #6c757d;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.gift-close-button:hover {\n    background: #545b62;\n}\n\n@media (max-width: 768px) {\n    .gift-banner-gifts {\n        grid-template-columns: 1fr;\n    }\n\n    .gift-modal {\n        margin: 10px;\n    }\n\n    .gift-modal-body {\n        padding: 20px;\n    }\n\n    .gift-reward-display {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .gift-modal-footer {\n        flex-direction: column;\n    }\n\n    .gift-claim-button {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
